import { LINK_CONFIG } from '../link-config';
const ɵ0 = LINK_CONFIG;
export class AppModule {
}
export { ɵ0 };
